import backgroundImage from "./assets/images/Saas_theme.webp"
import AppRoutes from "./Routes/AppRoutes";

export default function App() {
  return (
    <div className="w-full min-h-[100dvh] bg-transparent relative overflow-auto">
      <div
        className="fixed inset-0 opacity-90 -z-10 pointer-events-none"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div className="relative z-10">
        <AppRoutes />
      </div>
    </div>
  );
}
